import { createResourceCollection } from '@/request'
import { Plan } from '@/types'

export const plansCollection = createResourceCollection<Plan>({
  name: 'plansCollection',
  selector: (state) => state.plansCollection,
})

export default plansCollection.slice.reducer
